var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['flex gap-2', _vm.longDescription ? 'items-top' : 'items-center']},[_c('input',{class:[
            `rounded border-gray-300 focus:ring-${_vm.colorScheme}-500`,
            _vm.backgroundClass,
            _vm.disabled ? 'cursor-not-allowed' : 'cursor-pointer',
            _vm.sizeClass,
        ],attrs:{"disabled":_vm.disabled,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"click":_vm.updateValue}}),_c('label',{class:['cursor-pointer flex items-center', _vm.fullWidth ? 'w-full' : ''],on:{"click":_vm.updateValue}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }